import { FC } from 'react';
import StudentDetail from './StudentDetail';
import UseStudentDetail from './UseStudentDetail';

const StudentDetailContainer: FC = () => {
  return <StudentDetail {...UseStudentDetail()} />;
};

export default StudentDetailContainer;
